// extracted by mini-css-extract-plugin
export default {"wrapper":"DispathReLog_wrapper__smzvq"};